import { createContext, useContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ResolveRoute<P extends { [key: string]: any } = {}> = (routeName: string, params?: P) => string;
export interface ContextProps {
    resolveRoute: ResolveRoute;
}

export const ResolveRouteContext = createContext({} as unknown as ContextProps);

export const createRouteResolveProvider =
    <P,>(contextValue: ContextProps) =>
    (props: P) => <ResolveRouteContext.Provider value={contextValue} {...props} />;

export const useResolveRoute = () => useContext(ResolveRouteContext).resolveRoute;
